import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from "~/ui/styled"
import {
  Flex,
  ColumnFlex,
  CenterFlex,
  BetweenFlex,
  Text,
  IconFont,
  StartFlex,
} from "~components/El"
import Select from "../components/Select"
import { NotDisturbModeScreenProps } from "./types"
import { useSafeAreaInsets } from "~/ui/safe-area"

const Container = styled.ScrollView`
  flex-direction: column;
  flex: 1;
  padding: 0 12px;
`

const columns = [
  { label: "跟随系统", alias: "跟随系统设置", desc: "自动使用设备系统语言设置", value: "system" },
  { label: "简体中文", alias: "简体中文", desc: "系统默认语言", value: "2m" },
  { label: "繁体中文", alias: "繁體中文", desc: "台湾、香港地区使用的中文", value: "3m" },
  { label: "英语", alias: "English", desc: "English (United States)", value: "4m" },
  { label: "日语", alias: "日本語", desc: "日本で使用される言語", value: "5m" },
  { label: "韩语", alias: "한국어", desc: "한국에서 사용되는 언어", value: "6m" },
]
const TipCur : React.FC<any> = ({ icon,title='',content='',color='',bg='' }) => {
return <BetweenFlex bg={bg} style={{
  borderRadius: 8,
  alignItems:"flex-start",
  marginTop:10,
  padding:10
}}>
  <IconFont flex={1} name={icon} size={16} color={color}/>
  <ColumnFlex flex={11}>
  <Text color={color} fontWeight={600} fontSize='14px' mb={4}>{title}</Text>
  <Text color={color} fontSize='12px' lineHeight={18}>{content}</Text>
  </ColumnFlex>
</BetweenFlex>
}
const LabelComponent = ({ item, active }) => {
  const theme = useTheme()
  return (
    <StartFlex flex={9} style={{ paddingRight: 8 }}>
      <CenterFlex
        style={{
          width: 36,
          height: 36,
          borderRadius: 18,
          backgroundColor: theme.colors.primaryText + "22",
          marginRight: 12,
        }}
      >
        <IconFont
          name={item.value === "system" ? "gensuixitong" : "yuyan"}
          size={16}
          color={theme.colors.primaryText}
        />
      </CenterFlex>
      <ColumnFlex>
        <Text>{item.label}</Text>
        <Text fontSize="12" color={theme.colors.infoText} mt="6">
          {item.alias || "暂无描述"}
        </Text>
        <Text fontSize="12" color={theme.colors.infoText} mt="6">
          {item.desc || "暂无描述"}
        </Text>
      </ColumnFlex>
    </StartFlex>
  )
}
const LanguageSettings: React.FC<NotDisturbModeScreenProps> = ({ route }) => {
  const theme = useTheme()
  const [preset, setPreset] = useState("")
    const insets = useSafeAreaInsets()
  return (
    <Container style={{ marginBottom: insets.bottom}}>
      <Flex
        flexDirection="column"
        width="100%"
        mt="10px"
        padding="10px 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <BetweenFlex>
          <Text flex={1} color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600">
            <IconFont name="yuyan" size={16} color={theme.colors.purpleBackground} />
            &nbsp;&nbsp;当前语言
          </Text>
          <Text>跟随系统</Text>
        </BetweenFlex>
        <Flex flexDirection="column" width="100%" mt="10px">
          <StartFlex>
            <Text
              color={theme.colors.secondaryText}
              fontSize={theme.fontSizes.md}
              lineHeight="22px"
            >
              选择应用界面显示的语言
            </Text>
          </StartFlex>
        </Flex>
      </Flex>
      <ColumnFlex
        width="100%"
        mt="10px"
        padding="0 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <Select
          title="可选语言"
          description="选择你偏好的界面语言"
          LabelComponent={LabelComponent}
          options={columns}
          value={preset}
          onChange={(val) => {
            setPreset(val)
          }}
        />
      </ColumnFlex>
      <TipCur title='语言切换说明' content='更改语言后需要重启应用才能完全生效。部分内容可能需要重新加载。' icon='ztdx' color={'#9a3412'} bg='#fffbeb'/>
      <TipCur title='跟随系统' content='选择"跟随系统"将自动使用你设备的系统语言设置，当系统语言改变时，应用语言也会自动调整。' icon='yuyan' color={theme.colors.primaryText} bg='#3187e219'/>
    </Container>
  )
}

export default observer(LanguageSettings)
